import { useCallback, useMemo, useState } from 'react';
import { resolveIndustry } from '@config/industryRegistry';
import { industryConfigs } from '@config/industries';
import { IndustryContext } from './industry-context.js';

export default function IndustryProvider({ children }) {
  const [key, setKey] = useState(() => resolveIndustry(window.location));

  const setIndustry = useCallback((nextKey) => {
    if (!nextKey || !industryConfigs[nextKey]) return;
    setKey((currentKey) => (currentKey === nextKey ? currentKey : nextKey));
  }, []);

  const value = useMemo(() => {
    const config = industryConfigs[key] ?? industryConfigs.default;
    return { key, config, setIndustry };
  }, [key, setIndustry]);

  return <IndustryContext.Provider value={value}>{children}</IndustryContext.Provider>;
}
